import React, { useContext, useEffect, useState } from "react";

import dashboardServices from "../../../services/hoa-dashboard-api-service";
import datastore from "../../../store/hoa-datastore";

import { GlobalContext } from "../../../context/hoa-global-context";

import HoaAppLog from "../../hoa-app-log/hoa-app-log";
import OverView from "./hoa-property-overview";
import Violation from "./hoa-property-violation";
import MailTab from "./hoa-property-mail";
import EmailTab from "./hoa-property-email";

const mailTabHeading = 65;
const emailTabHeading = 99;
const changeLogTitle = 62;
const toolbar = 64;
const filterComponent = 103;
const tabHeader = 48;
const tableHeader = 57;
const responsiveHeight = toolbar + filterComponent + tableHeader + tabHeader + 1;

interface propertyViewProps {
	tabIndex: number;
	violationList: any;
	isViolationLoading: boolean;
	setViolationLists:any;
	hoaDueList: any;
	setHoaDueLists: any;
	isHoaDueLoading: boolean;
}

const PropertyViewContainer = ({
	tabIndex,
	violationList,
	isViolationLoading,
	setViolationLists,
	hoaDueList,
	setHoaDueLists,
	isHoaDueLoading
}: propertyViewProps) => {
	const { selectedValues } = useContext<any>(GlobalContext);
	const [isLogLoading, updateLogLoading] = useState(false);
	const [hoa, setHoa] = useState({});
	const [isEmptyViolationStatus, setEmptyViolationStatus] = useState(false);
	const [isHoaFetched,setIsHoaFetched] = useState(false);
	const [emails,setEmails] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
    })
	const [mails,setMails] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
    })
	const [appLogs,setAppLogs] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
    })
	const numberOfProjects = Math.ceil((window.innerHeight - datastore.responsiveHeight) / 60);

	const getCreatedLogs = async (page: number, options?: any) => {
		updateLogLoading(true);
		const {status, data} = await dashboardServices.getCreatedLogs(selectedValues.objectId, numberOfProjects, page, options);
		if(status == 200) {
			const { createdlogs, totalCount } = data;
			let isLastPage = [...appLogs.data, ...createdlogs].length >= totalCount
			datastore.createdLogs[selectedValues.objectId] = createdlogs;
			if(Object.values(options).length){
				let tempLogs = {...appLogs};
				tempLogs.data = createdlogs;
				tempLogs.pageNumber = 1;
				tempLogs.isLastPage = isLastPage;
				tempLogs.count = totalCount;
	
				datastore.createdLogs[selectedValues.objectId] = tempLogs;
				setAppLogs(tempLogs);
			}else{
				const mergedLogs = [...appLogs.data, ...createdlogs];
				const uniqueLogs = mergedLogs.filter(
					(log, index, self) =>
						index === self.findIndex((t) => t.objectId === log.objectId)
				);
				let tempLogs = {...appLogs};
				tempLogs.data = uniqueLogs;
				tempLogs.pageNumber = appLogs.pageNumber+1;
				tempLogs.isLastPage = isLastPage;
				tempLogs.count = totalCount;
	
				datastore.createdLogs[selectedValues.objectId] = tempLogs;
				setAppLogs(tempLogs);
			}
			updateLogLoading(false);
		}
	};

	const getHOAbyId = async () => {
		setIsHoaFetched(true)
		const { data: hoa } = await dashboardServices.getHoaById(selectedValues.hoaId, datastore.selectedOrganization?.id);
		setHoa(hoa);
		setIsHoaFetched(false)
	};

	const isViolationEmpty = () => {
		const values = [
			"violationFeeOutstanding",
			"totalViolation",
			"numberOfViolation",
			"avgViolation",
			"assesmentFee",
			"assesmentFeeFrequency",
			"assesmentStatus",
			"penalty",
			"penaltyAdditionalInfo",
			"penaltyFeePending",
			"hearingDate",
			"hearingPlace",
			"hearingNoticeFiles",
			"hearingAttorneyNeeded",
			"hearingStatementNeeded",
			"assessmentFeeSubHoa",
			"assessmentFeeFrequencySubHoa"
		];

		if (violationList.length > 0) return false;

		for (let title of Object.keys(selectedValues.hoaPropertyDetails)) {
			if (values.includes(title) && selectedValues.hoaPropertyDetails[title] !== "") {
				return false;
			}
			if (values.includes('hearingNoticeFiles') && selectedValues?.hearingNoticeFiles?.length != 0) {
				return false;
			}
		}

		return true;
	};

	useEffect(() => {
		setEmptyViolationStatus(isViolationEmpty());
	}, [isViolationLoading]);

	useEffect(() => {
		if (!datastore.createdLogs[selectedValues.objectId]) {
			getCreatedLogs(appLogs.pageNumber, {});
		} else {
			setAppLogs(datastore.createdLogs[selectedValues.objectId]);
		}
		if(selectedValues.hoaId) {
			getHOAbyId();
		}

		return () => {
			setHoa({});
			setAppLogs({
				count: null,
				data: [],
				isLastPage: false,
				pageNumber: null
			})
		};
	}, [selectedValues.objectId]);

	return (
		<>
			{tabIndex === 0 ? (
				<OverView isHoaFetched={isHoaFetched} hoa={hoa} overviewDetails={selectedValues} />
			) : tabIndex === 1 ? (
				!isEmptyViolationStatus ? (
					<Violation
						isViolationLoading={isViolationLoading}
						violationList={violationList}
						violationDetails={selectedValues}
						setViolationLists={setViolationLists}
						isHoaDueLoading={isHoaDueLoading}
						hoaDueList={hoaDueList}
						setHoaDueLists={setHoaDueLists}
					/>
				) : (
					<NoDataAvailable
						title={"No Violation Added Yet"}
						subTitle={"Please click on edit to add violations for this property"}
					/>
				)
			): tabIndex === 2 ? (
				<MailTab mails={mails} setMails={setMails} selectedValues={selectedValues} height= {window.innerHeight - (datastore.responsiveHeight+mailTabHeading)}/>
			): tabIndex === 3 ? (
				<EmailTab emails={emails} setEmails={setEmails} selectedValues={selectedValues} height= {window.innerHeight - (datastore.responsiveHeight+emailTabHeading)}/>
			) : (
				<HoaAppLog type={"Property"} isLogLoading={isLogLoading} updateLogLoading={updateLogLoading} appLogs={appLogs} setAppLogs={setAppLogs} getAssignedLogs={getCreatedLogs} height= {window.innerHeight - (datastore.responsiveHeight+changeLogTitle)}/>
			)}
		</>
	);
};

export const NoDataAvailable = (props: any) => {
	const { title, subTitle } = props;
	return (
		<div
			style={{
				height: "100%",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<img style={{ width: "200px", height: "200px" }} src="images/logo/no-wallpaper.png" />
			<span style={{ marginTop: "12px" }} className="text-787878-24px">
				{title}
			</span>
			<span style={{ marginTop: "10px" }} className="text-787878-16px">
				{subTitle}
			</span>
		</div>
	);
};

export default PropertyViewContainer;
